import { ToPartialMatchOptions } from 'Shared/utilities/MapDiscriminatedUnion';
import { Dependents } from 'ApplicationEntry/models/Dependents';
import * as I from 'immutable';

export class InvalidDependentList {
  public readonly key = 'InvalidDependentList';

  constructor(public readonly dependentList: I.List<Dependents>) { }
}

export class ValidDependentList {
  public static create(dependentList: I.List<Dependents>) {
    const dependentListArrayLength = dependentList.size;
    const haveAtLeastOneDependent = dependentListArrayLength > 0;

    return haveAtLeastOneDependent ? new ValidDependentList(dependentList) : new InvalidDependentList(dependentList);
  }

  public readonly key = 'ValidDependentList';
  private constructor(public readonly dependentList: I.List<Dependents>) { }
}

export type DependentLists = InvalidDependentList | ValidDependentList;

export type DependentListOptions<TReturn> = ToPartialMatchOptions<DependentLists, 'key', TReturn>;

export const matchDependentLists = <TReturn>(options: DependentListOptions<TReturn>) => (app: DependentLists): TReturn => {
  switch (app.key) {
    case 'InvalidDependentList':
      return options.InvalidDependentList ? options.InvalidDependentList(app) : options.default(app);
    case 'ValidDependentList':
      return options.ValidDependentList ? options.ValidDependentList(app) : options.default(app);
  }
};

export const addDependents = (dependent: I.List<Dependents>) => (dependentList: I.List<Dependents>) => {
  const existingList: I.List<Dependents> = dependentList;
  const newList = existingList.concat(dependent);
  
  return ValidDependentList.create(newList);
};

export const removeDependents = (index: number) => (dependentList: I.List<Dependents>) => {
  const existingList: I.List<Dependents> = dependentList;
  const newList = existingList.delete(index);

  return ValidDependentList.create(newList);
};

export const updateDependentList = (dependent: Dependents, index: number) => (dependentList: I.List<Dependents>) => {
  const existingList: I.List<Dependents> = dependentList;
  let newList: I.List<Dependents> = existingList;
  
  newList = existingList.splice(index, 1, dependent);

  return ValidDependentList.create(newList);
};

export const EmptyDependentList = new InvalidDependentList(I.List<Dependents>());
export const MAX_DEPENDENTS = 19;